module.exports = __webpack_public_path__ + "media/images/profile/about-yourself-info-f06f00f3d9ae7c711825b53984e853cf.svg";